<template>
    <div>
      <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
      </loading>
        <div class="modal hide fade" id="modalSale" tabindex="-1" role="dialog" aria-labelledby="modalSale" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                          Sale
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-inline ml-auto">
                                    <div class="button-group">
                                        <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshSales">
                                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                                        </button>
                                    </div>
                                    <div class="button-group">
                                        <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter
                                            <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu p-2" >
                                            <span>Company:</span>
                                            <div class="dropdown-divider"></div>
                                            <li v-for="c in companyList" :key="c.id">
                                                <a href="#" class="small" tabIndex="-1">
                                                    <input type="checkbox" :value="c.company_no" v-model="filterCompany"/>&nbsp; {{ c.name }}
                                                </a>
                                            </li>
                                            <span>Status:</span>
                                            <div class="dropdown-divider"></div>
                                            <li><a href="#" class="small" tabIndex="-1"><input type="checkbox" v-model="filterStatus" value="approved"/> Approved</a></li>
                                            <li><a href="#" class="small" tabIndex="-1"><input type="checkbox" v-model="filterStatus" value="outstanding"/> Outstanding</a></li>
                                        </ul>
                                        rows:
                                        <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                                            <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                                        </select>
                                        <span class="mr-1">
                                            Total rows: <b>{{ filterData.length }}</b>
                                        </span>
                                        <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshSales"></date-picker>
                                    </div>
                                    <div class="form-group mx-sm-3 mb-2">
                                        <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                                    </div>
                                    <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                                    <nav aria-label="Page navigation example" class="pull-right">
                                        <ul class="pagination">
                                            <li class="page-item">
                                                <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                                </a>
                                            </li>
                                            <li class="page-item">
                                                <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                                <table class="table table-sm table-item table-striped table-hover">
                                    <thead>
                                      <th>Status</th>
                                      <th>Sale No.</th>
                                      <th>Date</th>
                                      <th>Company</th>
                                      <th>Customer</th>
                                      <th>Sales</th>
                                      <th>#</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="s in filterData" :key="s.id">
                                          <td>
                                            <span class="badge badge-success" v-if="s.status === 'Open'">{{ s.status }}</span>
                                            <span class="badge badge-warning" v-else-if="s.status === 'outstanding'">{{ s.status }}</span>
                                            <span class="badge badge-primary" v-else-if="s.status === 'approved'">{{ s.status }}</span>
                                            <span class="badge badge-warning" v-else-if="s.status === 'order'">{{ s.status }}</span>
                                            <span class="badge badge-danger" v-else>{{ s.status }}</span>
                                          </td>
                                          <td>{{ s.sale_no }}</td>
                                          <td>{{ s.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                          <td>{{ s.company }}</td>
                                          <td>{{ s.customer_name }}</td>
                                          <td>{{ s.salesman }}</td>
                                          <td><button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" @click="select(s.id)">Select</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { salesUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'

export default {
  name: 'SaleSelectModal',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    const date1 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    return {
      filterCompany: ['C0001', 'C0002'],
      loadingSales: true,
      filterStatus: [],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      checkFilter: []
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      saleStatusList: state => state.sales.saleStatusList,
      companyList: state => state.companies.companyList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterStatus.length > 0) {
          for (let i = 0; i < this.filterStatus.length; i++) {
            if (d.status === this.filterStatus[i]) {
              return d
            } else if (this.filterStatus[i] === 'outstanding') {
              if (d.total_payment < d.total) {
                return d
              }
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no === this.filterCompany[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  mounted () {
    this.refreshSales()
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    refreshSales () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: null
      }
      var url = salesUrl + '/list'
      axios.post(url, obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    select: function (id) {
      var data = this.dataRaw.find(d => d.id === id)
      this.$emit('selectSales', data)
    }
  }
}
</script>
